/** @jsx jsx */
import React from 'react';
import { jsx, css } from '@emotion/core';
import { useTheme } from '../theme';
const Line = React.forwardRef((props, ref) => {
    const theme = useTheme();
    return (jsx("div", Object.assign({}, props, { ref: ref, css: css `
          position: relative;
          margin: 0;

          counter-increment: line-number 1;

          &::before {
            position: absolute;
            left: -30px;
            width: 30px;
            pointer-events: none;

            color: ${theme.colors.line.number};
            font-size: small;
            content: counter(line-number) ' ';
            text-align: right;
          }
        ` })));
});
Line.displayName = 'Line';
export default React.memo(Line);
//# sourceMappingURL=Line.js.map